define("shared/validations/tax-id-validation", ["exports", "ember-changeset-validations/validators", "later/utils/is-env"], function (_exports, _validators, _isEnv) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-changeset-validations/validators",0,"later/utils/is-env"eaimeta@70e063a35619d71f
  /**
   * Validates Entered VAT Number to match format expected by the BE, BE requires a proper format and will error
   * without the correct prefixes.
   * Combines both GB vat and EU vat formats, we allow saving any format regardless of users address
   *
   * On non-production environments the following ids are also allowed for testing
   * 000000000 - Successful validation
   * 111111111 - Failed validation
   * 222222222 - Perpetually pending
   */
  const STRIPE_TEST_IDS = new RegExp(/^(000000000|111111111|222222222)$/);
  const TAX_ID_REGEX = [
  // GB VAT
  new RegExp(/^GB([0-9]{9}|[0-9]{12}|(HA|GD)[0-9]{3})$/),
  //United Kingdom

  // EU VAT
  new RegExp(/^ATU[0-9]{8}$/),
  //Austria
  new RegExp(/^BE[01][0-9]{9}$/),
  //Belgium
  new RegExp(/^BG[0-9]{9,10}$/),
  //Bulgaria
  new RegExp(/^CY[0-9]{8}[A-Z]$/),
  //Cyprus
  new RegExp(/^CZ[0-9]{8,10}$/),
  //Czech Republic
  new RegExp(/^DE[0-9]{9}$/),
  //Germany
  new RegExp(/^DK[0-9]{8}$/),
  //Denmark
  new RegExp(/^EE[0-9]{9}$/),
  //Estonia
  new RegExp(/^EL[0-9]{9}$/),
  //Greece
  new RegExp(/^ES([A-Z][0-9]{8}|[0-9]{8}[A-Z]|[A-Z][0-9]{7}[A-Z])$/),
  //Spain
  new RegExp(/^FI[0-9]{8}$/),
  //Finland
  new RegExp(/^FR[A-Z0-9]{2}[0-9]{9}$/),
  //France
  new RegExp(/^HR[0-9]{11}$/),
  //Croatia
  new RegExp(/^HU[0-9]{8}$/),
  //Hungary
  new RegExp(/^IE([0-9][A-Z][0-9]{5}|[0-9]{7}[A-Z]?)[A-Z]$/),
  //Ireland
  new RegExp(/^IT[0-9]{11}$/),
  //Italy
  new RegExp(/^LT([0-9]{9}|[0-9]{12})$/),
  //Lithuania
  new RegExp(/^LU[0-9]{8}$/),
  //Luxembourg
  new RegExp(/^LV[0-9]{11}$/),
  //Latvia
  new RegExp(/^MT[0-9]{8}$/),
  //Malta
  new RegExp(/^NL[0-9]{9}B[0-9]{2}$/),
  //Netherlands
  new RegExp(/^XI[0-9]{9}$/),
  //Northern Ireland
  new RegExp(/^PL[0-9]{10}$/),
  //Poland
  new RegExp(/^PT[0-9]{9}$/),
  //Portugal
  new RegExp(/^RO[1-9][0-9]{1,9}$/),
  //Romania
  new RegExp(/^SE[0-9]{12}$/),
  //Sweden
  new RegExp(/^SI[0-9]{8}$/),
  //Slovenia
  new RegExp(/^SK[0-9]{10}$/) //Slovakia
  ];
  var _default = _exports.default = {
    businessName: [(0, _validators.validatePresence)({
      presence: true
    }), (0, _validators.validateLength)({
      min: 1
    })],
    taxId: [(0, _validators.validatePresence)({
      presence: true
    }), validateTaxId(), (0, _validators.validateLength)({
      min: 7
    })],
    didConfirm: [(0, _validators.validatePresence)({
      presence: true
    }), validateVatCheckbox()]
  };
  function validateVatCheckbox() {
    return (_key, newValue) => {
      if (newValue === true) {
        return true;
      }
      // Note: message is not output to user.
      return 'Must confirm VAT is valid and correct.';
    };
  }
  function validateTaxId() {
    if (!(0, _isEnv.isProduction)()) {
      TAX_ID_REGEX.push(STRIPE_TEST_IDS);
    }
    return (_key, newValue) => {
      const match = TAX_ID_REGEX.some(taxIdRegex => taxIdRegex.test(newValue));
      if (match) {
        return true;
      }
      // Note: message is not output to user.
      return 'Invalid VAT format';
    };
  }
});